import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Calculates a CoIntegration model with forecasts.
 *
 * @param {object} _this - Context variables (component state or Vue instance).
 * @param {string} yStr - Name of the dependent variable.
 * @param {string} yHist - Historical values of the dependent variable.
 * @param {string} xAssets - Names of independent variables.
 * @param {string} xHist - Historical values of independent variables.
 * @param {string} xFcst - Forecast values for independent variables.
 * @returns {Promise<void>} - Resolves when the model data is fetched and processed.
 */
export function getCoIntegrationForecast(
  _this,
  yStr,
  yHist,
  xAssets,
  xHist,
  xFcst
) {
  // Set loading state to true indicating model calculation is in progress
  Object.assign(_this.loading, { model: true });

  // Prepare API request parameters
  const params = {
    method: "POST",
    endpoint: "cointegration_fcst",
    content_type: "application/json",
    query_params: {
      format: "json",
      xAssets: JSON.stringify(xAssets),
      xFcst: JSON.stringify(xFcst),
      xHist: JSON.stringify(xHist),
      yHist: JSON.stringify(yHist),
      yStr: yStr
    }
  };
  // Perform API request to fetch co-integration model data
  return apiService
    .getAll(params)
    .then(data => {
      parseData(_this, data); // Parse and update state with fetched data
    })
    .catch(error => {
      // Handle errors and reset loading state
      console.error("Error fetching co-integration forecast data:", error);
      Object.assign(_this.loading, { model: false });
    });
}

/**
 * Parses the forecast data and updates the context state.
 *
 * @param {object} _this - Context variables (component state or Vue instance).
 * @param {Array} data - Array of forecast data returned from the API.
 */
function parseData(_this, data) {
  // Convert date strings to JavaScript Date objects using timeParseNull2
  data.forEach(d => {
    d.date = timeParseNull2(d.date);
  });
  // Update context with model data and set loading state to false
  Object.assign(_this.data, { model: data });
  Object.assign(_this.loading, { model: false });
}
